import { render, staticRenderFns } from "./MinionEdit.vue?vue&type=template&id=55be048e&scoped=true&"
import script from "./MinionEdit.vue?vue&type=script&lang=js&"
export * from "./MinionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be048e",
  null
  
)

export default component.exports